// The backend stores a notification's `link` as an app path. Only these are
// ones the manager has a page for; `/contacts/:id` and `/conversations/:id`
// are served by alias routes in App.jsx, which also catch them when they
// arrive from a push notification. Anything else is not navigated to — the
// catch-all route would silently land the user on the home page.
// growchat-doc/manager-notification-page/spec-manager-notification-page.md
const EXACT_PAGES = ['/inbox', '/bookings', '/customers']
const DETAIL_PREFIXES = ['/contacts/', '/conversations/']

export function isKnownNotificationLink(link) {
  if (typeof link !== 'string' || !link.startsWith('/') || link.startsWith('//')) return false
  const path = link.split(/[?#]/, 1)[0]
  if (EXACT_PAGES.includes(path)) return true
  return DETAIL_PREFIXES.some((prefix) => path.startsWith(prefix) && path.length > prefix.length)
}
